import { createModule } from '../../createModule';
import { parseInput } from '../../shared';
import { createGuidelineSchema, deleteGuidelineSchema, updateGuidelineSchema, } from './ic-guidelines.schemas';
export const createICGuidelinesAPI = createModule(({ http, streaming }) => {
    const streamReport = (params) => streaming.stream({
        path: '/v2/ic_guidelines/report/stream',
        ...params,
    });
    return {
        getTemplate: async () => {
            return await http.get(`/v2/ic_guidelines/template`);
        },
        getSummary: async ({ fund_name, value_date }) => {
            return await http.get(`/v2/ic_guidelines/risk/summary/${fund_name}/${value_date}`);
        },
        getProtection: async ({ fund_name, value_date }) => {
            return await http.get(`/v2/ic_guidelines/risk/protection/${fund_name}/${value_date}`);
        },
        getBeta: async ({ fund_name, value_date }) => {
            return await http.get(`/v2/ic_guidelines/risk/beta/${fund_name}/${value_date}`);
        },
        getIncome: async ({ fund_name, value_date }) => {
            return await http.get(`/v2/ic_guidelines/risk/income/${fund_name}/${value_date}`);
        },
        getCurrencyExposures: async ({ fund_name, value_date }) => {
            return await http.get(`/v2/ic_guidelines/risk/currency_exposures/${fund_name}/${value_date}`);
        },
        getMTM: async ({ fund_name, value_date }) => {
            return await http.get(`/v2/ic_guidelines/risk/mtm/${fund_name}/${value_date}`);
        },
        getVectors: async ({ fund_name, value_date }) => {
            return await http.get(`/v2/ic_guidelines/risk/diversifiers/${fund_name}/${value_date}`);
        },
        downloadExcel: async ({ fund_name, value_date }) => {
            return await http.get(`/v2/ic_guidelines/file/${fund_name}/${value_date}`, {
                responseType: 'arraybuffer',
            });
        },
        forwardEmail: async ({ fund_name, value_date }) => {
            return await http.get(`/v2/ic_guidelines/email/${fund_name}/${value_date}`);
        },
        runReports: async (body) => {
            return await http.post(`/v2/ic_guidelines/store_to_db`, { body });
        },
        v2: {
            streamReport,
            getGuidelines: async () => {
                return await http.get('/v2/ic_guidelines/guidelines');
            },
            getConfig: async () => {
                return await http.get(`/v2/ic_guidelines/content-block-config`);
            },
            createGuideline: async (params) => {
                const body = parseInput(createGuidelineSchema, params);
                return await http.post(`/v2/ic_guidelines/guideline`, { body });
            },
            updateGuideline: async (params) => {
                const body = parseInput(updateGuidelineSchema, params);
                return await http.patch(`/v2/ic_guidelines/guideline/${body.guideline.id}`, {
                    body,
                });
            },
            deleteGuideline: async (params) => {
                const body = parseInput(deleteGuidelineSchema, params);
                return await http.delete(`/v2/ic_guidelines/guideline/${body.guideline_id}`);
            },
        },
    };
});
